import { render } from "./SmilesPopupViewer.vue?vue&type=template&id=3d53bb52&scoped=true&ts=true"
import script from "./SmilesPopupViewer.vue?vue&type=script&lang=ts"
export * from "./SmilesPopupViewer.vue?vue&type=script&lang=ts"

import "./SmilesPopupViewer.vue?vue&type=style&index=0&id=3d53bb52&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d53bb52"]])

export default __exports__